(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-testid="collection-list-v2"]');
    if (!section) return;

    const videos = section.querySelectorAll('.collection-card__video');
    if (!videos.length) return;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const MAX_CONCURRENT = isMobile ? 2 : Infinity;
    const ratios = new Map();

    function getPlaying() {
      return Array.from(videos).filter(v => !v.paused);
    }

    function ensureLimit() {
      let playing = getPlaying();
      while (playing.length > MAX_CONCURRENT) {
        let minRatio = Infinity, victim = null;
        for (const v of playing) {
          const r = ratios.get(v) || 0;
          if (r < minRatio) { minRatio = r; victim = v; }
        }
        if (victim) { victim.pause(); playing = playing.filter(v => v !== victim); }
        else break;
      }
    }

    function tryPlay(video) {
      if (!video.paused) return;
      const playing = getPlaying();
      if (playing.length < MAX_CONCURRENT) {
        video.play().catch(() => {});
        return;
      }
      const newRatio = ratios.get(video) || 0;
      let minRatio = Infinity, victim = null;
      for (const v of playing) {
        const r = ratios.get(v) || 0;
        if (r < minRatio) { minRatio = r; victim = v; }
      }
      if (victim && newRatio >= minRatio) {
        victim.pause();
        video.play().catch(() => {});
      }
    }

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          ratios.set(entry.target, entry.intersectionRatio);
        } else {
          ratios.delete(entry.target);
        }
      }
      for (const entry of entries) {
        if (!entry.isIntersecting && !entry.target.paused) {
          entry.target.pause();
        }
      }
      for (const entry of entries) {
        if (entry.isIntersecting) {
          tryPlay(entry.target);
        }
      }
      ensureLimit();
    }, {
      rootMargin: '100px',
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    videos.forEach(v => observer.observe(v));

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        videos.forEach(v => v.pause());
      } else {
        videos.forEach(v => tryPlay(v));
      }
    });

    window.addEventListener('pagehide', () => {
      videos.forEach(v => v.pause());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
